import Container from './FolderActionsDropdown.container';
import FolderActionsDropdown from './FolderActionsDropdown';

export default Container(FolderActionsDropdown);
